import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import axios from "axios";
import lodash from "lodash";
import DigiFormItem from "../DigiForm/DigiFormItem";
import SlideInspectionTasks from "./SlideInspectionTasks";

class SlideInspectionForm extends React.Component {
  state = {
    loading: false,
    done: false,
    fieldErrors: {},
    formFields: this.props.formFields,
    selectedLocation: this.props.locationsWithSlides[this.props.locationId],
    selectedSlide: this.props.locationsWithSlides[this.props.locationId].slides[this.props.slideId],
    slideInspectionTasks: [],
    inspectionCertified: false
  };

  componentDidMount() {
    const slideInspectionTasks = this.props.formFields.slide_inspection_tasks_attributes.slideInspectionsTasks;
    const formFields = this.props.formFields;
    formFields["slide_inspection_tasks_attributes"].value = slideInspectionTasks;
    this.setState({
      slideInspectionTasks: slideInspectionTasks,
      formFields: formFields
    });
  }

  render() {
    const {
      loading,
      fieldErrors,
      formFields,
      selectedLocation,
      selectedSlide,
      locationsWithSlides,
      slideInspectionTasks,
      inspectionCertified
    } = this.state;

    const {
      formType,
      locationOptions,
      locationId,
      slideId
    } = this.props;

    return (
      <div>
        <form onSubmit={this.submit}>
          <DigiFormItem
            key="location_id"
            formFieldKey="location_id"
            formField={{
              "type": "select",
              "label": "Location",
              "required": false,
              "value": selectedLocation.id || locationId,
              "select_options": locationOptions,
              "enabled": (formType == "new")
            }}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
          <DigiFormItem
            key="slide_id"
            formFieldKey="slide_id"
            formField={{
              "type": "select",
              "label": "Feature",
              "required": false,
              "value": selectedSlide.id || slideId,
              "select_options": this.props.locationsWithSlides[selectedLocation.id || locationId].slides,
              "enabled": (formType == "new")
            }}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
          <SlideInspectionTasks
            slideInspectionTasks={this.state.slideInspectionTasks}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
          {Object.keys(formFields).map((formField, index) =>
            <DigiFormItem
              key={index}
              formFieldKey={formField}
              formField={formFields[formField]}
              fieldErrors={fieldErrors}
              stateEnabled={formFields[formField].useStateToggle ? this.state.selectedSlide[`${formField}_toggle`] : formFields[formField].toggle}
              onChange={this.handlerChangeField}
            />
          )}

          {inspectionCertified ? (
            <button
              className={classnames("btn btn-block btn-pink", {
                disabled: false
              })}
              type="submit"
            >SAVE
            </button>
          ) : (
              <span className="certification-text">
                <a
                  className="btn btn-text slide-inspection-certify-button"
                  tabIndex={0}
                  onClick={this.handleCertificationClick}
                  onKeyDown={(e) => e.key === "Enter" && this.handleCertificationClick(e)}
                >
                  I CERTIFY ALL ITEMS HAVE BEEN INSPECTED
                </a>
              </span>
          )}
        </form>
      </div>
    );
  }

  buildSlideInspectionTasks = (slideInspectionTemplateTasks) => {
    return slideInspectionTemplateTasks.map(task => ({
      _id: moment().valueOf() + (Math.floor(Math.random() * 1000) + 1),
      task_name: task.name,
      completed: true,
      note: ""
    }));
  };

  handleCertificationClick = (e) => {
    e.preventDefault();
    this.setState({inspectionCertified: true});
  }

  handlerChangeField = (newValue, key) => {
    if (newValue == "--") { return }
    const formFields = this.state.formFields;
    !(key in formFields) && (formFields[key] = {});
    formFields[key].value = newValue;

    this.setState({ formFields: formFields, fieldErrors: {}, inspectionCertified: false });

    if (key == "location_id") {
      const newSlide = Object.values(this.props.locationsWithSlides[newValue].slides)[0];
      const newSlideInspectionTasks = this.buildSlideInspectionTasks(
        newSlide.slide_inspection_template_tasks
      );
      formFields["slide_id"] = {value: newSlide.id};
      formFields["slide_inspection_tasks_attributes"].value = newSlideInspectionTasks;
      this.setState({
        selectedLocation: this.props.locationsWithSlides[newValue],
        selectedSlide: newSlide,
        slideInspectionTasks: newSlideInspectionTasks,
        formFields: formFields
      });
    }

    if (key == "slide_id") {
      const newSlideInspectionTasks = this.buildSlideInspectionTasks(
        this.state.selectedLocation.slides[newValue].slide_inspection_template_tasks
      );
      formFields["slide_inspection_tasks_attributes"].value = newSlideInspectionTasks;
      formFields["slide_id"] = {value: newValue};
      this.setState({
        selectedSlide: this.state.selectedLocation.slides[newValue],
        slideInspectionTasks: newSlideInspectionTasks,
        formFields: formFields
      })
    }
  };

  processRailsErrors = (errorFields) => {
    const fieldErrors = this.state.fieldErrors;
    Object.keys(errorFields).forEach(errorFieldKey => {
      fieldErrors[errorFieldKey] = errorFields[errorFieldKey];
    });
    this.setState({ fieldErrors: fieldErrors });
  };

  buildDataForm = () => {
    const data = new FormData();

    Object.keys(this.state.formFields).forEach(key => {
      let value = this.state.formFields[key].value;

      if (Array.isArray(value)) {
        value.forEach(nestedFields => {
          let nestedFieldId = nestedFields.id ? nestedFields.id : nestedFields._id;
          Object.keys(nestedFields).forEach(nestedKey => {
            data.append(`${this.props.formName}[${key}][${nestedFieldId}][${nestedKey}]`, nestedFields[nestedKey]);
          })
        })
      } else {
        data.append(`${this.props.formName}[${key}]`, value);
      };
    });

    return data;
  };

  submit = e => {
    e.preventDefault();

    let that = this;

    if (this.state.loading) {
      return;
    }

    const data = this.buildDataForm();

    this.setState({ loading: true });

    const request = this.props.formType == "edit"
      ? axios.put(
          this.props.formUrl,
          data
        )
      : axios.post(
          this.props.formUrl,
          data
        );

    request
      .then(request => {
        toastr.success(this.props.formType == "edit" ? "Feature Inspection Updated" : "Feature Inspection Created");
        this.setState({ done: true, loading: false });

        setTimeout(() => {
          window.location.href = "/slide_inspections/";
        }, 700);
      })
      .catch(function(error) {
        toastr.error("There is an error, please check");
        that.processRailsErrors(error.response.data);
        that.setState({ loading: false, done: false });
      });
  };
}

SlideInspectionForm.propTypes = {
  formType: PropTypes.string,
  formName: PropTypes.string,
  formUrl: PropTypes.string,
  formFields: PropTypes.object
};

export default SlideInspectionForm;
